import React from "react";
import { motion } from "framer-motion";
import FadeInView from "./FadeInView";
import {
  Share2,
  MessageSquare,
  BarChart3,
  AlertTriangle,
  Activity,
  FileText,
} from "lucide-react";

const FEATURES = [
  {
    icon: Share2,
    title: "Multi-AI Review",
    desc: "Run the same legal issue through multiple AI models and compare where they agree, disagree, or identify different risks.",
  },
  {
    icon: MessageSquare,
    title: "Adversarial Debate",
    desc: "Assign Advocate, Critic, and Strategist roles to stress-test your position before opposing counsel does.",
  },
  {
    icon: BarChart3,
    title: "Comparative Analysis",
    desc: "See where the models agree, where they diverge, and which reasoning is most useful for your legal strategy.",
  },
  {
    icon: AlertTriangle,
    title: "Ranked Vulnerabilities",
    desc: "Identify missing facts, weak authority, procedural risks, and arguments likely to be attacked — ranked by litigation impact.",
  },
  {
    icon: Activity,
    title: "Final Synthesis",
    desc: "Convert competing AI outputs into one clear strategy with practical next steps.",
  },
  {
    icon: FileText,
    title: "Executive Summaries",
    desc: "Turn long analysis into concise summaries for review, revision, or client communication.",
  },
];

export default function NewLandingFeatures() {
  return (
    <section className="features-section">
      <div className="features-inner">
        <FadeInView>
          <p className="section-eyebrow">What&apos;s Inside</p>
          <h2 className="section-headline">
            Built for How Attorneys Pressure-Test Arguments.
          </h2>
        </FadeInView>
        <FadeInView delay={0.08}>
        <p className="section-sub nl-features-sub">
          LawFusion was built ground-up for attorneys — not retrofitted from a
          generic chatbot. It helps you compare AI reasoning, test opposing
          arguments, surface weak spots, and turn competing outputs into a
          clearer litigation strategy.
        </p>
        </FadeInView>
        <div className="features-grid">
          {FEATURES.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={title}
              className="feature-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
              whileHover={{ y: -4 }}
            >
              <div className="feature-icon">
                <Icon size={20} aria-hidden="true" />
              </div>
              <div className="feature-title">{title}</div>
              <div className="feature-desc">{desc}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
